/* FRAME — optional resources library interactions; no external dependencies. */
(()=>{
  'use strict';
  const init = (root)=>{
    if (root.dataset.frameResourceReady==='true') return;
    root.dataset.frameResourceReady='true';
    const search=root.querySelector('[data-frame-resource-search]');
    const buttons=[...root.querySelectorAll('[data-frame-resource-filter]')];
    const cards=[...root.querySelectorAll('[data-frame-resource-card]')];
    const count=root.querySelector('[data-frame-resource-count]');
    const empty=root.querySelector('[data-frame-resource-empty]');
    if(!cards.length) return;
    let category='all';
    const update=()=>{
      const query=(search?.value||'').trim().toLocaleLowerCase();
      let shown=0;
      cards.forEach((card)=>{
        const categoryMatch=category==='all'||card.dataset.category===category;
        const match=categoryMatch&&(!query||(card.dataset.search||'').toLocaleLowerCase().includes(query));
        card.hidden=!match;
        if(match)shown++;
      });
      if(count)count.textContent=`${shown} ${shown===1?'resource':'resources'}`;
      if(empty)empty.hidden=shown!==0;
    };
    buttons.forEach((button)=>button.addEventListener('click',()=>{
      category=button.dataset.frameResourceFilter||'all';
      buttons.forEach((item)=>{
        const active=item===button;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',String(active));
      });
      update();
    }));
    search?.addEventListener('input',update);
    update();
  };
  const initialize=(scope=document)=>{
    scope.querySelectorAll('[data-frame-resource-library]').forEach(init);
    if(scope.matches?.('[data-frame-resource-library]'))init(scope);
    const feedback=scope.querySelector('[data-frame-form-feedback]');
    if(feedback && !feedback.dataset.frameFeedbackFocused){
      feedback.dataset.frameFeedbackFocused='true';
      feedback.focus({preventScroll:true});
    }
  };
  initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
